import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheckIcon, BadgeCheckIcon, DownloadIcon, LockIcon, HeadphonesIcon } from 'lucide-react';
export function ProductOffer() {
  const checkoutUrl = 'http://checkout.sabores365.online/cart/59169685471313:1';
  const trustItems = [{
    icon: ShieldCheckIcon,
    text: 'Pago seguro'
  }, {
    icon: BadgeCheckIcon,
    text: 'Garantía 45 días'
  }, {
    icon: DownloadIcon,
    text: 'Descarga inmediata'
  }, {
    icon: LockIcon,
    text: 'Protección de datos'
  }, {
    icon: HeadphonesIcon,
    text: 'Soporte 24/7'
  }];
  return <section id="compra" className="py-20 px-4 bg-[#FEF3E2] scroll-mt-10" data-id="element-94">
      <div className="max-w-4xl mx-auto" data-id="element-95">
        <div className="bg-white rounded-3xl p-8 md:p-12 border-2 border-[#EA580C] shadow-[0_0_40px_rgba(234,88,12,0.15)] relative overflow-hidden" data-id="element-96">
          {/* Top Banner */}
          <div className="absolute top-0 left-0 right-0 bg-red-600 text-white text-center py-2 font-bold text-sm tracking-wider" data-id="element-97">
            OFERTA POR TIEMPO LIMITADO
          </div>

          <div className="mt-8 text-center space-y-6" data-id="element-98">
            <div className="flex justify-center items-center gap-2 text-red-500 font-bold mb-4" data-id="element-99">
              <span data-id="element-100">La oferta termina en:</span>
              <CountdownTimer data-id="element-101" />
            </div>

            <div className="space-y-2" data-id="element-102">
              <p className="text-[#92400E] text-xl line-through decoration-red-500 decoration-2" data-id="element-103">
                Precio normal: $30,990
              </p>
              <div className="flex justify-center items-baseline gap-2" data-id="element-104">
                <span className="text-5xl md:text-7xl font-black text-[#3C1518]" data-id="element-105">
                  $19,990
                </span>
                <span className="text-xl text-[#EA580C] font-bold" data-id="element-106">ARS</span>
              </div>
            </div>

            <p className="text-[#5C2D0E] text-lg max-w-xl mx-auto py-6" data-id="element-107">
              Descarga inmediata. Acceso instantáneo. Disponible desde cualquier
              celular, tablet o computador.
            </p>

            <a href={checkoutUrl} className="block w-full py-5 px-8 bg-[#EA580C] hover:bg-[#C2410C] text-white text-xl md:text-2xl font-black rounded-xl transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(234,88,12,0.25)]" data-id="element-108">
              ¡SÍ, QUIERO MI RECETARIO AHORA!
            </a>

            <div className="pt-8 flex flex-wrap justify-center gap-4 md:gap-8 border-t border-[#E8D5C0] mt-8" data-id="element-109">
              {trustItems.map((item, index) => <div key={index} className="flex items-center gap-2 text-[#92400E]" data-id="element-110">
                  <item.icon className="w-4 h-4 text-[#EA580C]" data-id="element-111" />
                  <span className="text-xs md:text-sm" data-id="element-112">{item.text}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}